import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    commingSoonCitiesList,
    commingSoonCitiesAdd,
    commingSoonCitiesUpdate,
    commingSoonCitiesRemove
} from "../../Redux/Actions/comingSoonCitiesActions";
import { columnsCommingSoonCitiesList } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";
import CommingSoonCityEditModal from "./addUpdateComingSoonCities";
import { Button, Modal } from "antd";

const ListCommingSoonCities = () => {
    const dispatch = useDispatch();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);
    const [tempSearch, setTempSearch] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
    });

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    const cityState = useSelector((state) => state.commingSoonCities || {});
    const settingsId = useMemo(() => {
        return cityState.cities?.data?.data?.settings_id ||
            new URLSearchParams(window.location.search).get('setting_id');
    }, [cityState.cities]);

    const cities = useMemo(() => {
        return cityState.cities?.data?.data?.cities || [];
    }, [cityState.cities]);

    const cityTotal = useMemo(() => {
        return cityState.cities?.data?.data?.total_count || cities.length;
    }, [cityState.cities, cities]);

    const { loading } = cityState;

    const fetchDetails = useCallback(() => {
        return dispatch(commingSoonCitiesList({})).catch(() => {
            toast.error("Failed to fetch cities list");
        });
    }, [dispatch]);

    useEffect(() => {
        fetchDetails();
    }, [fetchDetails]);

    useEffect(() => {
        setPagination((prev) => ({ ...prev, total: cityTotal }));
    }, [cityTotal]);

    const openEditModal = useCallback((city = null) => {
        setSelectedCity(city);
        setIsModalOpen(true);
    }, []);

    const closeEditModal = () => {
        setSelectedCity(null);
        setIsModalOpen(false);
    };

    const filterHandler = () => {
        setSearchQuery(tempSearch);
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    const handleDelete = (cityId) => {
        Modal.confirm({
            title: "Confirm Delete",
            content: "Are you sure you want to delete this city?",
            okText: "Yes, Delete",
            okType: "danger",
            cancelText: "Cancel",
            onOk: async () => {
                try {
                    await dispatch(commingSoonCitiesRemove({
                        _id: settingsId,
                        city_id: cityId
                    }));
                    fetchDetails();
                } catch (error) {
                    toast.error("Failed to delete city");
                }
            },
        });
    };

    const handleSubmit = async (values) => {
        try {
            let result;

            if (selectedCity?._id) {
                result = await dispatch(commingSoonCitiesUpdate({
                    _id: settingsId,
                    updated_by: "admin",
                    comming_soon_cities: [{
                        _id: selectedCity._id,
                        name: values.name,
                        url: values.url,
                        description: values.description
                    }]
                }));
            } else {
                result = await dispatch(commingSoonCitiesAdd({
                    _id: settingsId,
                    comming_soon_cities: [{
                        name: values.name,
                        url: values.url,
                        description: values.description
                    }]
                }));
            }

            if (result) {
                fetchDetails();
                closeEditModal();
                toast.success(selectedCity?._id ? "City updated!" : "City added!");
                return { success: true };
            }
        } catch (error) {
            toast.error("Failed to save city");
            return { success: false };
        }
    };


    const handleTableChange = (pagination) => {
        setPagination(pagination);
    };

    return (
        <>
            <div style={{ position: "absolute", marginTop: "9.6%", marginLeft: "89%" }}>
                {canAdd &&
                    <Button
                        style={{ background: "#0D1A52", color: "white", padding: "18px", borderRadius: "20px" }}
                        onClick={() => openEditModal(null)}
                        disabled={!settingsId}
                    >
                        Add City
                    </Button>
                }
            </div>

            <TableComponent
                pagination={pagination}
                filterFunction={filterHandler}
                onPressEnter={filterHandler}
                setState={setTempSearch}
                dataSource={cities}
                onChange={handleTableChange}
                h3heading="Coming Soon Cities"
                columns={columnsCommingSoonCitiesList(pagination.current, pagination.pageSize, handleDelete, openEditModal, canEdit)}
                loading={loading}
            />

            {isModalOpen && (
                <CommingSoonCityEditModal
                    visible={isModalOpen}
                    cityData={selectedCity}
                    onSave={handleSubmit}
                    onClose={closeEditModal}
                    settingsId={settingsId}
                />
            )}
        </>
    );
};

export default ListCommingSoonCities;
